import { AccessTime, KeyboardArrowDownOutlined as KeyboardArrowDownOutlinedIcon } from '@mui/icons-material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { Badge, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Menu, MenuItem, Popover, Stack, Theme, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import { Formik } from 'formik';
import * as React from 'react';
import { Userpilot } from 'userpilot';
import * as yup from "yup";
import { useCheckBooleanSetting } from '../../../contexts/SettingsContext';
import useTableSort from '../../../hooks/useTableSort';
import { getAdminSettingsList, getAgentDetailById, getAgentEvents, getAgentList, getAgentStateDetail, getContinuousBargeStatus, getUserBargeDetails, getWidgetConfig, logoutAgent, releaseAgent } from '../../../services/api-service';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import { isSubAdmin } from '../../../services/auth-service';
import { widgetService } from '../../../services/widgets-service';
import { ReactComponent as DragIcon } from '../../../static/icons/drag.svg';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import { ReactComponent as ScreenBargeinIcon } from '../../../static/icons/screenBargein.svg';
import { STATUS_CLASS_MAP, WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import { checkDataAccessFilters, checkRoles, checkSettings, determineFilterType, filterRowsBySearch, getColumnId, getLengthOfProps, getLevelColor, getUpdatedFilterType, mapRowDataWithThreshold, secondsToMinSec, secondsToTime } from '../../../utils/util';
import CustomizedCheckbox from '../../admin/common/CustomCheckBox';
import { showErrorNotification, showSuccessNotification } from '../../admin/common/NotiService';
import OZInput from '../../admin/common/OZInput';
import VideoPlayerIcon from '../../admin/common/VideoPlayer/VideoPlayer';
import BargeInDrawerSip from '../../BargeinDrawerSip/BargeinDrawerSip';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import SelectPopover from '../../SelectPopover/SelectPopover';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import WidgetGraph from '../../Widget-Graph/Widget-Graph';
import WidgetSearch from '../../Widget-Search/Widget-Search';
import '../AgentCurrentState/AgentCurrentState.css';
import VirtualTable from './VirtualTable';

interface Column {
	id:
	| 'AgentName'
	| 'agentAction'
	| 'HoldDuration'
	| 'Since'
	| 'AgentState'
	| 'CallStatus'
	| 'adminAction'
	| 'hamburger'
	| 'CampaignNameOfLastCall'
	| 'CallFrom_SkillName'
	| 'CallType'
	| 'CustomerPhoneNumber'
	| 'AgentMode'
	| 'AgentId'
	| 'SkillsFormatted'
	| 'GroupsFormatted'
	| 'HoldStatus'
	| 'AgentPhoneNumber'
	| 'sip_location'
	label: string;
	minWidth?: number;
	draggable?: boolean;
	align?: 'right' | 'left' | 'center';
	positionIndex?: number;
	type?: string;
}
const useStyles: any = makeStyles((theme: Theme) => ({
	popoverContent: {
		minWidth: 350,
		fontSize: '12px',
		lineHeight: 2
	},
	dragdropItemsWrapper: {
		display: 'flex',
		height: '100%',
		width: '100%',
		margin: '0 1rem',
		alignItems: 'center'
	},
	dropdownSearchContainer: {
		height: '30px',
		border: '1px solid #D6D6D7',
		borderRadius: '8px',
		backgroundColor: '#F2F2F2'
	},
	searchContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#FFFFFF',
		height: '28px',
		borderLeft: '1px solid #D6D6D7',
		borderRadius: '0px 8px 8px 0px',
		width: '193px',
		padding: '0px 8px'
	},
	searchInput: {
		border: 'none',
		outline: 'none'
	},
	dropdownLabelMenuItem: {
		fontWeight: '400 !important',
		fontSize: '12px !important',
		lineHeight: '14px !important',
		color: '#212121 !important',
		width: '149px'
	},
	dropdownMenu: {
		minWidth: 'fit-content !important',
		border: '1px solid #e6e5e6 !important',
		boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04) !important',
		borderRadius: '12px !important',
		marginTop: '10px !important'
	},
	dropdownMenuItem: {
		fontWeight: '400 !important',
		fontSize: '12px !important',
		lineHeight: '14px !important',
		color: '#212121 !important'
	},
}));

const defaultColumns: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120 },
	{ id: 'agentAction', label: '', minWidth: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
	},
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
	},
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
	{ id: 'sip_location', label: 'SIP Location', minWidth: 120 },
	{ id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
	// { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
	{
		id: 'AgentMode',
		label: 'Mode',
		draggable: true,
		minWidth: 100,
	},
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
	// { id: 'HoldStatus', label: 'Hold Status', minWidth: 120 },
	{ id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
	{ id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
	{ id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
	{
		id: 'adminAction',
		label: 'Admin Action',
		minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
	},
	{ id: 'hamburger', label: '', minWidth: 20 }
];

const columnsWithoutDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120 },
	{ id: 'agentAction', label: '', minWidth: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
	},
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
	},
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
	{ id: 'sip_location', label: 'SIP Location', minWidth: 120 },
	{ id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
	// { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
	{
		id: 'AgentMode',
		label: 'Mode',
		draggable: true,
		minWidth: 100,
	},
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 120, draggable: true },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
	{ id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
	{ id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
	{ id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
	{
		id: 'adminAction',
		label: 'Admin Action',
		minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
	},
	{ id: 'hamburger', label: '', minWidth: 20 }
];

const columnsWithDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 110 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 120 },
	{ id: 'agentAction', label: '', minWidth: 30 },
	{
		id: 'CampaignNameOfLastCall',
		label: 'Campaign Name',
		draggable: true,
	},
	{
		id: 'CallFrom_SkillName',
		label: 'Call From Skill',
		draggable: true,
	},
	{ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true },
	{
		id: 'CallType',
		label: 'Call Type',
		draggable: true,
		minWidth: 50,
	},
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
	{ id: 'sip_location', label: 'SIP Location', minWidth: 120 },
	{ id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
	// { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
	{
		id: 'AgentMode',
		label: 'Mode',
		draggable: true,
		minWidth: 100,
	},
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 120, draggable: true },
	{ id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
	{ id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
	{ id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
	{
		id: 'adminAction',
		label: 'Admin Action',
		minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
	},
	{ id: 'hamburger', label: '', minWidth: 20 }
];

const defaultDownloadColumns: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 120 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 80 },
	{ id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true },
	{ id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true },
	{ id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 },
	{ id: 'sip_location', label: 'SIP Location', minWidth: 50 },
	{ id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true },
	// { id: 'GroupsFormatted', label: 'Groups', minWidth: 50 },
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50 },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' },
	{ id: 'AgentState', label: 'State', draggable: true, minWidth: 50 },
	{ id: 'CallStatus', label: 'Last Call Status', minWidth: 50 },
	{ id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' },
];

const downloadColumnsWithDataAccess: Column[] = [
	{ id: 'AgentId', label: 'Agent Id', minWidth: 120 },
	{ id: 'AgentName', label: 'Agent Name', minWidth: 80 },
	{ id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true },
	{ id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true },
	{ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true },
	{ id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 },
	{ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 },
	{ id: 'sip_location', label: 'SIP Location', minWidth: 50 },
	{ id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true },
	// { id: 'GroupsFormatted', label: 'Groups', minWidth: 50 },
	{ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 },
	{ id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 },
	{ id: 'HoldStatus', label: 'Hold Status', minWidth: 50 },
	{ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' },
	{ id: 'AgentState', label: 'State', draggable: true, minWidth: 50 },
	{ id: 'CallStatus', label: 'Last Call Status', minWidth: 50 },
	{ id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' },
];

const thresholdItemsDefault = [
	// {
	// 	label: 'Idle',
	// 	key: 'AgentState',
	// 	value: 'IDLE',
	// 	fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	// },
	{
		label: 'Ready',
		key: 'AgentState',
		value: 'READY',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	},
	{
		label: 'Busy',
		key: 'AgentState',
		value: 'BUSY',
		fields: [
			{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
			{ label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
		]
	},
	{
		label: 'ACW',
		key: 'AgentState',
		value: 'ACW',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	},
	{
		label: 'Pause',
		key: 'AgentState',
		value: 'PAUSED',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	},
	// {
	// 	label: 'Calling',
	// 	key: 'AgentState',
	// 	value: 'CALLING' || 'Calling',
	// 	fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	// },
	{
		label: 'AUX',
		key: 'AgentState',
		value: 'AUX',
		fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
	}
];

export default function AgentCurrentState(props: any) {

	const fullscreenContainer = props?.fullscreenContainer
	const { useState, useRef } = React;
	const classes = useStyles();
	const [responseLength, setresponseLength] = useState<Number>(0);
	const [allowedFilters, setAllowedFilters] = useState<string[]>(['Campaign', 'Skill', 'Group', 'CampaignType']);
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columns, setColumns] = useState<Array<any>>(defaultColumns);
	const [downloadColumns, setDownloadColumns] = useState<Array<any>>(defaultDownloadColumns);
	const [filteredRowData, setFilteredRowData] = useState<Array<any>>([]);
	const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
	const [isEventsPopoverOpen, setIsEventsPopoverOpen] = useState<boolean>(false);
	const [isColumnsPopoverOpen, setIsColumnsPopoverOpen] = useState<boolean>(false);
	const [isBargeInOpen, setIsBargeInOpen] = useState<boolean>(false);
	const [eleRefPoint, setElRefPoint] = useState<any>(null);
	const [columnsEleRefPoint, setColumnsElRefPoint] = useState<any>(null);
	const [selectedAgent, setSelectedAgent] = useState<any>(null);
	const [selectedAgentDetails, setSelectedAgentDetails] = useState<any>(null);
	const [selectedAgentEventDetails, setSelectedAgentEventDetails] = useState<any>(null);
	const [selectedColumns, setSelectedColumns] = useState<any>(props?.selectedFilters?.filterHeaders?.data || columns);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || (checkDataAccessFilters() ? 3 : 1));
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [agentListFilter, setAgentListFilter] = useState<any>(props?.selectedFilters?.filters || []);
	const [groupingColumns, setGroupingColumns] = useState<any>(props?.widgetData?.groupingColumns || []);
	const [groupedData, setGroupedData] = useState<any>({});
	const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
	const [thresholdItems, setThresholdItems] = useState<Array<any>>(thresholdItemsDefault);
	const [openAlert, setOpenAlert] = React.useState(false);
	const [openLogOffAlert, setOpenLogOffAlert] = React.useState(false);
	const [openLogConfigAlert, setOpenLogConfigAlert] = React.useState(false);
	const [logConfigDetails, setLogConfigDetails] = React.useState<any>([]);
	const [releaseDetails, setReleaseDetails] = React.useState<any>([]);
	const [logOffDetails, setLogOffDetails] = React.useState<any>([]);
	const [searchText, setSearchText] = useState<any>({});
	const searchTextRef = useRef('');
	const [sipClient, setSipClient] = useState<any>("");
	const [sipUrl, setSipUrl] = useState<any>("");
	const [bargeinCallType, setBargeinCallType] = useState<any>("");
	const [onselect, setOnSelect] = useState(false);
	const [settings, setSettings] = useState<any>([]);
	const [continuousBarge, setContinuousBarge] = useState(false);
	const tableContainerRef = useRef(null);
	const tableDataRef = useRef(null);
	const [resized, setResized] = useState<any>(false);
	const [moreData, setMoreData] = useState<any>(false);
	const [selectedDownloadData, setSelectedDownloadData] = useState<any>(downloadColumns);
	const [screenBargeinData, setScreenBargeinData] = useState<any>(null);
	const [searchFieldMenuAnchorEl, setSearchFieldMenuAnchorEl] = useState<any>(null);
	const [onlyBargeinMode] = useState<any>(true);
	const labelOpen = Boolean(searchFieldMenuAnchorEl);
	const [searchSelect, setSearchSelect] = useState<any>({ name: 'Agent Name', key: 'AgentName' });
	const searchKeyRef = useRef('');
	const [savedThresholdList, setSavedThresholdList] = useState<any>({
		thresholdList: props?.selectedThresholds?.thresholdList?.length ? props?.selectedThresholds?.thresholdList : [],
		showSkillList: props?.selectedThresholds?.showSkillList || false
	});
	const [bulkSelectedAgents, setBulkSelectedAgents] = useState<string[]>([]);
	const [bulkActionLoading, setBulkActionLoading] = useState<'release' | 'logout' | null>(null);
	const isBulkSelectionActive = bulkSelectedAgents?.length > 0;
	const getAgentIncId = (agent: any) => agent?.AgentIncId ?? agent?.AgentUniqueId ?? '';
	const { sortData, handleSort, getSortIcon, getSortedGroupData, sortGroupedData } = useTableSort({
		defaultSortConfig: { key: 'AgentName', direction: 'ascending' }
	});
	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const [bulkActions, setBulkActions] = useState(false);
	const prevAdditionalFilters = React.useMemo(() => {
		if (props?.selectedFilters?.extraParams) {
			try {
				return (JSON.parse(props.selectedFilters.extraParams));
			}
			catch (err) {
				console.error("Error parsing extraParams", err);
				return { state: [], mode: [] }
			}
		}
		return { state: [], mode: [] }
	}, [props?.selectedFilters?.extraParams]);

	const logConfigFormValidationSchema = React.useMemo(
		() => yup.object({
			logDuration: yup.number()
				.min(1, "Log Duration limit can be set between a range of 1-30 minutes")
				.max(30, "Log Duration limit can be set between a range of 1-30 minutes")
				.required("Duration is required")
		}), []
	)

	const [additionalFilters, setAdditionalFilters] = useState<any>(prevAdditionalFilters);

	const additionalFiltersLength = React.useMemo(() => {
		let count = 0;
		if (additionalFilters?.state?.length) {
			count += additionalFilters.state.length;
		}
		if (additionalFilters?.mode?.length) {
			count += additionalFilters.mode.length;
		}
		return count;
	}, [additionalFilters]);

	const [isAdminActionSettingEnabled, setAdminActionSetting] = useState(false);
	const enableLogDuration = useCheckBooleanSetting("TOOLBAR_LOG_DURATION");

	const intervalRef = useRef<any>(null);
	const loadingRef = useRef<boolean>(false);
	const isRealTimeSkillUpdateRef = useRef<boolean>(false);


	React.useEffect(() => {
		const checkAdminActionSetting = async () => {
			try {
				const resp = await checkSettings("DSBL_ADMNACT_IF_BUSY");
				console.log("isAdminActionSettingEnabled ~ resp:", resp)
				setAdminActionSetting(resp)
			}
			catch (err) {
				console.log(err);
			}
		}
		checkAdminActionSetting();
	}, [])

	React.useEffect(() => {
		selectedDownloadColumns();
	}, [selectedColumns])

	React.useEffect(() => {
		if (savedThresholdList && savedThresholdList.thresholdList && savedThresholdList.thresholdList.length) {
			console.log('thresholdItems savedThresholdList useEffect', savedThresholdList);
			setThresholdItems(savedThresholdList.thresholdList);
		}
	}, [savedThresholdList.thresholdList]);

	React.useEffect(() => {
		const filterHeaders = props?.selectedFilters?.filterHeaders?.data;
		const dataAccessEnabled = checkRoles("ROLE_DATA_ACCESS");
		if (dataAccessEnabled) {
			setColumns(columnsWithDataAccess);
			setDownloadColumns(downloadColumnsWithDataAccess);
			setSelectedDownloadData(downloadColumnsWithDataAccess);
		} else {
			setColumns(columnsWithoutDataAccess);
			setDownloadColumns(defaultDownloadColumns);
			setSelectedDownloadData(defaultDownloadColumns);
		}
		if (filterHeaders && Array.isArray(filterHeaders)) {
			const currColumns = (dataAccessEnabled ? columnsWithDataAccess : defaultColumns);
			const filteredColumns = filterHeaders?.filter((column) => currColumns?.filter((col) => col.id == column.id));
			setSelectedColumns(filteredColumns);
		}
	}, []);

	React.useEffect(() => {
		const fetchWidgetConfig = async () => {
			try {
				if (checkDataAccessFilters()) {
					let widgetConfig = await getWidgetConfig('104', 'widget');
					if (widgetConfig) {
						if (typeof widgetConfig === 'string') {
							widgetConfig = JSON.parse(widgetConfig);
						}
						// Check the condition and set the appropriate filters
						const filters = widgetConfig.data && checkDataAccessFilters()
							? widgetConfig.data
							: widgetConfig.config;

						if (filters) {
							const filtersArray = filters.split(',');
							setAllowedFilters(filtersArray);
							const determinedFilterType = determineFilterType(filtersArray);
							if (determinedFilterType !== undefined) {
								setFilterType(determinedFilterType);
							}
						}
					}
				}
			} catch (error) {
				console.error('Error fetching widget config:', error);
			}
		};
		fetchWidgetConfig();
	}, []);

	React.useEffect(() => {
		Userpilot.initialize('456987');
		Userpilot.identify('456987',
			{
				userid: localStorage.getItem("userId"),
				username: localStorage.getItem("userName")
			}
		);
		Userpilot.track('AgentsList-Active', { name: localStorage.getItem("userName") });
		const resizeObserver = new ResizeObserver((entries) => {
			if (entries && entries.length > 0) {
				const newHeight: any = entries[0].target.clientHeight;
				if (parseInt(newHeight) > 488) {
					setResized(true)
				}
				if (parseInt(newHeight) === 408) {
					setResized(false)
				}
				if (parseInt(newHeight) === 618) {
					setResized(false)
				}
				else if (parseInt(newHeight) >= 748) {
				}
			}
		});

		const resizeDataObserver = new ResizeObserver((entries) => {
			if (entries && entries.length > 0) {
				const Height: any = entries[0].target.clientHeight;
				if (parseInt(Height) > 280) {
					setMoreData(true)
				}
			}
		});

		if (tableContainerRef.current) {
			resizeObserver.observe(tableContainerRef.current);
		}

		if (tableDataRef.current) {
			resizeDataObserver.observe(tableDataRef.current);
		}

		return () => {
			resizeObserver.disconnect();
			resizeDataObserver.disconnect()
		};
	}, []);


	async function agentListRealTimeSkillUpdate() {
		try {
			const resp = await checkSettings("AG_REAL_TIME_SKL_UPD");
			if (resp && (resp === true || resp === "true")) {
				isRealTimeSkillUpdateRef.current = true;
			} else {
				isRealTimeSkillUpdateRef.current = false;
			}
		} catch (error) {
			console.log("Error in agentListRealTimeSkillUpdate", error);
		}
	}

	React.useEffect(() => {
		try {
			if (checkRoles("ROLE_DATA_ACCESS")) {
				agentListRealTimeSkillUpdate();
			}
		} catch (error) {
			console.log("Error in agentListRealTimeSkillUpdate", error);
		}
	}, []);

	const selectedDownloadColumns: any = () => {
		const selectedHeaders: Column[] = selectedColumns;
		if (props?.selectedFilters?.filterHeaders?.data) {
			const filterData = downloadColumns.filter(item1 =>
				selectedHeaders.some(item2 => item1.id === item2.id)
			);
			setSelectedDownloadData(filterData);
		}
	}

	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: '#F0F1F2',
			color: '#000000',
			padding: '10px 16px'
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
			padding: '10px 16px'
		}
	}));
	const agentDetailsItems = [
		{ label: 'Total Login', key: 'TotalLoginDuration', type: true },
		{ label: 'Last Logout', key: 'LastLogoutTime' },
		{ label: 'Calls Offered', key: 'TotalCalls' },
		{ label: 'Answered', key: 'AnsweredCalls' },
		{ label: 'Abandoned', key: 'AbandonedCalls' },
		{ label: 'Average Hold Time', key: 'AverageHoldDuration', type: true },
		{ label: 'AHT', key: 'AverageHandlingDuration', type: true },
		{ label: 'ASA', key: 'AverageSpeedToAnswer', type: true },
		{ label: 'ACW', key: 'TotalWrapupDuration', type: true },
		{ label: 'Pause Time', key: 'TotalPauseDuration', type: true }
	];

	React.useEffect(() => {
		getSettings();
		continuousBargeEnabled();
	}, [bargeinCallType])

	React.useEffect(() => {
		console.log("ROLE_CONTINUE_BARGE , continuousBarge", checkRoles("ROLE_CONTINUE_BARGE"), continuousBarge)
		if (selectedAgent && checkRoles("ROLE_CONTINUE_BARGE") && continuousBarge) {
			const selectedAgentIncId = getAgentIncId(selectedAgent);
			const updatedData = rowData?.filter((item: any) => getAgentIncId(item) == selectedAgentIncId)
			if (updatedData.length > 0 && updatedData[0]?.AgentState != selectedAgent?.AgentState) {
				if (updatedData[0]?.AgentState === 'BUSY') {
					updatedData[0].continuousBarge = true;
				}
				setSelectedAgent(updatedData[0]);
			}
		}
	}, [rowData])

	// React.useEffect(() => {
	// 	// Only set the interval if isBargeInOpen is true
	// 	if (isBargeInOpen) {
	// 		const intervalId = setInterval(async () => {
	// 			if (selectedAgent && checkRoles("ROLE_CONTINUE_BARGE") && continuousBarge) {
	// 				try {
	// 					console.log("Trtch****************");
	// 					let agentDetail = await fetchAgentDetail();
	// 					if (agentDetail) {
	// 						if (typeof agentDetail === 'string') {
	// 							agentDetail = JSON.parse(agentDetail);
	// 						}
	// 						if(agentDetail[0]?.AgentState === 'BUSY') {
	// 							agentDetail[0].continuousBarge = true;
	// 						}
	// 						setSelectedAgent(agentDetail[0]);
	// 					}
	// 				} catch (error) {
	// 					console.log("Catch****************");
	// 					console.error("Failed to fetch agent details", error);
	// 				}
	// 			}
	// 		}, 2000); // 2 seconds interval

	// 		// Cleanup interval if isBargeInOpen is false or component unmounts
	// 		return () => clearInterval(intervalId);
	// 	}
	// }, [selectedAgent, continuousBarge, isBargeInOpen]);

	// Function to fetch agent details by ID
	const fetchAgentDetail = async () => {
		try {
			console.log("what is the selectedAgent--->", selectedAgent);
			let agentDetail = await getAgentDetailById(getAgentIncId(selectedAgent));
			if (agentDetail && typeof agentDetail === 'string') {
				agentDetail = JSON.parse(agentDetail);
			}
			return agentDetail;
		} catch (error) {
			console.error("Failed to fetch agent details", error);
			return null;
		}
	};

	const getPopoverContent = () => {
		return (
			<Box sx={{ p: 2 }} className={classes.popoverContent}>
				<div>
					{agentDetailsItems.map((item: any, idx: number) => (
						<Grid key={idx} container direction="row" justifyContent="space-between" alignItems="center">
							<Grid item xs={7}>
								<b>{item.label}</b>
							</Grid>
							{item.type ? <span>{secondsToTime(selectedAgentDetails?.[item.key]) || 0}</span> : <span>{selectedAgentDetails?.[item.key] || 0}</span>}
						</Grid>
					))}
				</div>
			</Box>
		);
	};

	const formatAMPM = (date: Date) => {
		if (date) {
			var hours = date.getHours();
			var minutes: any = date.getMinutes();
			var ampm = hours >= 12 ? 'PM' : 'AM';
			hours = hours % 12;
			hours = hours ? hours : 12; // the hour '0' should be '12'
			minutes = minutes < 10 ? '0' + minutes : minutes;
			var strTime = hours + ':' + minutes + ' ' + ampm;
			return strTime;
		} else {
			return '';
		}
	};

	const getColorByAgentEvent = (event: string) => {
		return event.toLowerCase() === 'calling'
			? 'yellow'
			: event.toLowerCase() === 'aux'
				? 'green'
				: event.toLowerCase() === 'release'
					? 'red'
					: event.toLowerCase() === 'idle'
						? 'orange'
						: event.toLowerCase() === 'incall'
							? 'lightgreen'
							: '';
	};

	const getTimeDifferenceInString = (higherDate: string, lowerDate: string) => {
		const seconds = (new Date(higherDate).getTime() - new Date(lowerDate).getTime()) / 1000;
		if (!isNaN(seconds)) {
			if (seconds > 60) {
				const minutes = seconds / 60;
				if (minutes > 60) {
					const hours = minutes / 60;
					return `${hours.toFixed(1)} Hrs`;
				} else {
					return `${Math.floor(minutes)} Mins`;
				}
			} else {
				return `${seconds} Secs`;
			}
		} else {
			return '';
		}
	};

	const getEventsPopoverContent = () => {
		return (
			<Box sx={{ p: 2 }} className={classes.popoverContent}>
				<div>
					<h3>{selectedAgent?.AgentName}</h3>
					<Stack direction={'column'} gap={1}>
						{selectedAgentEventDetails?.map((item: any, idx: number) => (
							<Box key={idx} display={'flex'} justifyContent="space-between" alignItems="center">
								<Box display={'flex'} gap={1}>
									{
										<Box
											sx={{
												background: getColorByAgentEvent(item.Event),
												width: '2px',
												height: '2rem',
												borderRadius: '4px'
											}}
										></Box>
									}
									<Box sx={{ display: 'flex', flexDirection: 'column' }}>
										<Stack direction={'row'} gap={5}>
											<Typography
												sx={{
													minWidth: '5rem',
													fontWeight: '500',
													fontSize: '12px',
													color: 'rgba(33, 33, 33, 0.7)'
												}}
											>
												{item.Event.toUpperCase()}
											</Typography>

											{item?.StartTime && item?.EndTime && (
												<Box
													sx={{
														display: 'flex',
														flexDirection: 'row',
														alignItems: 'center',
														gap: '5px',
														fontWeight: '400',
														fontSize: '12px',
														color: '#99A0A8'
													}}
												>
													<AccessTime sx={{ color: 'inherit', fontSize: '18px' }} />

													<Typography sx={{ color: 'inherit', fontSize: 'inherit' }}>{getTimeDifferenceInString(item?.EndTime, item?.StartTime)}</Typography>
												</Box>
											)}
										</Stack>
										<Typography
											sx={{
												fontWeight: '400',
												fontSize: '12px',
												color: '#99A0A8'
											}}
										>
											{formatAMPM(new Date(item?.StartTime))}
										</Typography>
									</Box>
								</Box>
							</Box>
						))}
					</Stack>
				</div>
			</Box>
		);
	};

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		'&:nth-of-type(even)': {
			backgroundColor: '#edf0f280'
		},
		// hide last border
		'&:last-child td, &:last-child th': {
			border: 0
		}
	}));

	const handleOnPopoverClose = () => {
		setElRefPoint(null);
		setSelectedAgent(null);
		setIsPopoverOpen(false);
	};

	const handleOnEventsPopoverClose = () => {
		setElRefPoint(null);
		setSelectedAgent(null);
		setIsEventsPopoverOpen(false);
	};

	const handleOnColumnsPopoverClose = () => {
		setColumnsElRefPoint(null);
		setIsColumnsPopoverOpen(false);
	};

	const handleToggleAgentSelection = (agent: any) => {
		const agentIncId = getAgentIncId(agent);
		if (!agentIncId) {
			return;
		}
		const agentId = String(agentIncId);
		setBulkSelectedAgents((prev) => {
			if (prev.includes(agentId)) {
				const next = prev.filter((id) => id !== agentId);
				return next;
			}
			return [...prev, agentId];
		});
	};

	const clearBulkSelection = () => {
		setBulkSelectedAgents([]);
	};

	const bulkReleaseAgentsUpdate = async (agentUniqueIds: string[], type: "bulkAgentsReleaseByAdmin" | "bulkAgentsLogoffByAdmin") => {
		try {
			if (!bulkSelectedAgents.length) {
				return;
			}
			setBulkActionLoading(type === "bulkAgentsReleaseByAdmin" ? 'release' : 'logout');
			const resp = await widgetService({
				bodyParams: {
					action: type,
					apiId: type === "bulkAgentsReleaseByAdmin" ? 51 : 52,
					agentUniqueIds: agentUniqueIds?.length === rowData?.length ? '0' : agentUniqueIds.join(','),
				},
				responseType: 'string',
				method: 'POST'
			});
			if (resp) {
				const responseString = await resp.text();
				let isJsonHandled = false;
				try {
					const jsonMsg = JSON.parse(responseString);
					if (jsonMsg && typeof jsonMsg === "object" && jsonMsg?.message) {
						showErrorNotification(jsonMsg.message);
						isJsonHandled = true;
					}
				} catch (e) {
				}

				if (!isJsonHandled && responseString.includes("success")) {
					showSuccessNotification(`Bulk Agent ${(type === "bulkAgentsReleaseByAdmin" ? "release" : "logout")} initiated for ${agentUniqueIds?.length || ''} agents`);
				}
			}
		} catch (error) {
			console.error('Bulk operation failed', type, error);
		} finally {
			setBulkActionLoading(null);
			clearBulkSelection();
		}
	};

	const handleBulkRelease = async () => {
		await bulkReleaseAgentsUpdate(bulkSelectedAgents, 'bulkAgentsReleaseByAdmin');
	}

	const handleBulkLogout = async () => {
		await bulkReleaseAgentsUpdate(bulkSelectedAgents, "bulkAgentsLogoffByAdmin");
	};

	const getBulkSelectionCell = (row: any, key: string | number) => {
		const agentIncId = getAgentIncId(row);
		const selectedAgentId = agentIncId ? String(agentIncId) : null;
		if (!selectedAgentId) {
			return <StyledTableCell key={`bulk-select-${key}`} align="center"></StyledTableCell>;
		}
		const isSelected = bulkSelectedAgents.includes(selectedAgentId);

		return (
			<StyledTableCell key={`bulk-select-${key}`} align="center" style={{ minWidth: 30, width: 30 }} >
				<CustomizedCheckbox
					size="small"
					checked={isSelected}
					onChange={() => handleToggleAgentSelection(row)}
				/>
			</StyledTableCell>
		);
	};

	const handleOnSelectColumnChange = (selected: any) => {

		let selectedIds: string[] = []
		let orderedSelected = [];

		selected.map((selected: any) => {
			selectedIds.push(selected.id)
		})

		if (selectedIds.includes("AgentId")) {
			orderedSelected.push({ id: 'AgentId', label: 'Agent Id', minWidth: 120 })
		}
		if (selectedIds.includes("AgentName")) {
			orderedSelected.push({ id: 'AgentName', label: 'Agent Name', minWidth: 80 })
		}
		if (selectedIds.includes("agentAction")) {
			orderedSelected.push({ id: 'agentAction', label: '', minWidth: 30 })
		}
		if (selectedIds.includes("CampaignNameOfLastCall")) {
			orderedSelected.push({ id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true })
		}
		if (selectedIds.includes("CallFrom_SkillName")) {
			orderedSelected.push({ id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true })
		}
		if (selectedIds.includes("CallType")) {
			orderedSelected.push({ id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 })
		}
		if (selectedIds.includes("AgentPhoneNumber")) {
			orderedSelected.push({ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 })
		}
		if (selectedIds.includes("sip_location")) {
			orderedSelected.push({ id: 'sip_location', label: 'SIP Location', minWidth: 50 })
		}
		if (selectedIds.includes("SkillsFormatted")) {
			orderedSelected.push({ id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("GroupsFormatted")) {
			orderedSelected.push({ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("CustomerPhoneNumber")) {
			orderedSelected.push({ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 })
		}
		if (selectedIds.includes("AgentMode")) {
			orderedSelected.push({ id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 })
		}
		if (selectedIds.includes("HoldStatus")) {
			orderedSelected.push({ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, draggable: true })
		}
		if (selectedIds.includes("HoldDuration")) {
			orderedSelected.push({ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' })
		}
		if (selectedIds.includes("AgentState")) {
			orderedSelected.push({ id: 'AgentState', label: 'State', draggable: true, minWidth: 50 })
		}
		if (selectedIds.includes("CallStatus")) {
			orderedSelected.push({ id: 'CallStatus', label: 'Last Call Status', minWidth: 50 })
		}
		if (selectedIds.includes("Since")) {
			orderedSelected.push({ id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' })
		}
		if (selectedIds.includes("adminAction")) {
			orderedSelected.push({ id: 'adminAction', label: 'Admin Action', minWidth: 185 })
		}
		if (selectedIds.includes("hamburger")) {
			orderedSelected.push({ id: 'hamburger', label: '', minWidth: 20 })
		}
		props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: orderedSelected });
		setSelectedColumns(orderedSelected);
		handleOnColumnsPopoverClose();
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const getTableData = async (filters = '0') => {
		try {
			if (loadingRef.current) return;
			loadingRef.current = true;
			let state = additionalFilters?.state?.length > 0 ? additionalFilters.state.join(',') : 'All';
			let mode = additionalFilters?.mode?.length > 0 ? additionalFilters.mode.join(',') : 'All';
			let data = await getAgentList({ filters, type: getUpdatedFilterType(filterType, 'number'), state, mode, apiId: (isRealTimeSkillUpdateRef.current) ? 504 : 104 });
			const updatedRowData = mapRowDataWithThreshold(thresholdItems, data);
			for (const row of updatedRowData) {
				const skills = row.AgentSkills?.split(',') || [];
				const groups = row.AgentGroups?.split(',') || [];
				const tempSkills = [...skills];
				const tempGroups = [...groups];
				if (groups.length > 1) {
					row.GroupsFormatted = (
						<div>
							{groups.slice(0, 1).join(',')}
							<span key="badge" className="badge" title={tempGroups.join(',')}>
								{`+${groups.length - 1}`}
							</span>
						</div>
					);
				}
				else {
					row.GroupsFormatted = groups.join(',');
				}
				if (skills.length > 1) {
					row.SkillsFormatted = (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<div style={{ display: 'inline-block', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
								{skills.slice(0, 1).join(',')}
							</div>
							<span key="badge" className="badge" title={tempSkills.join(',')}>
								{`+${skills.length - 1}`}
							</span>
						</div>
					);
				} else {
					row.SkillsFormatted = skills.join(',');
				}
				if (row && row.PauseReason) {
					row.AgentState = row.PauseReason
				}
				if (checkRoles('ROLE_CHAT_CALL') && row && row?.SessionCount && parseInt(row.SessionCount) > 0) {
					row.AgentState = "BUSY";
				}
				row.HoldStatus = 'Non-Hold'
				if (row && typeof row === "object" && row?.HoldDuration && "HoldDuration" in row && row.HoldDuration && (typeof row.HoldDuration === "number" || !isNaN(Number(row.HoldDuration)))) {
					row.HoldStatus = row.HoldDuration > 0 ? 'Hold' : 'Non-Hold'
				}
			}
			setRowData(updatedRowData);
			let filteredRows: any = [];
			const currentSearchText = searchTextRef?.current || '';
			if (currentSearchText?.length) {
				filteredRows = filterRowsBySearch({ rows: updatedRowData, searchKey: searchKeyRef.current, searchText: currentSearchText });
				// const filteredRows = updatedRowData.filter((item: any) => item.AgentName.toLowerCase().includes(searchText));
				setFilteredRowData(filteredRows);
			} else {
				setFilteredRowData(updatedRowData);
			}
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		} catch (error) {
			console.error("Failed to fetch agent list", error);
		} finally {
			loadingRef.current = false;
		}
	};

	const handleOnSearch = (event: any) => {
		const searchText = event.target.value.length ? event.target.value.toLowerCase() : '';
		setSearchText(searchText);
		if (searchKeyRef) {
			searchKeyRef.current = searchSelect?.key || '';
		}
		if (searchTextRef) {
			searchTextRef.current = searchText;
		}
		// setSearchTextForAgentID(event.target.value.length ? event.target.value : '')
		if (searchText?.length) {
			let filteredRows: any = [];
			filteredRows = filterRowsBySearch({ rows: rowData, searchKey: searchKeyRef.current, searchText });
			setFilteredRowData(filteredRows);
		} else {
			setFilteredRowData(rowData);
		}
	};

	React.useEffect(() => {
		handleOnSearch({ target: { value: searchText } });
	}, [searchSelect?.key]);

	const getSettings = () => {
		try {
			getAdminSettingsList()
				.then((resp: any) => {
					setSettings(resp.Data);
					resp?.Data?.map((item: any) => {
						if (item?.ParameterCode === "BARGEIN_CALL_TYPE") {
							if (item?.ParameterValue === null) {
								setBargeinCallType(item?.DefaultValue);
							} else if (item?.ParameterValue !== null) {
								setBargeinCallType(item?.ParameterValue);
							}
						}
						if (item?.ParameterCode === "BULK_AGENTS_OPS") {
							let enableBulkAction = false;
							if (item?.ParameterValue !== null) {
								if (item?.ParameterValue === "true" || item?.ParameterValue === true) {
									enableBulkAction = true;
								} else if (item?.ParameterValue === "false" || item?.ParameterValue === false) {
									enableBulkAction = false;
								}
							} else if (item?.ParameterValue === null) {
								if (item?.DefaultValue === "true" || item?.DefaultValue === true) {
									enableBulkAction = true;
								} else if (item?.DefaultValue === "false" || item?.DefaultValue === false) {
									enableBulkAction = false;
								}
							}
							if (!isSubAdmin()) {
								setBulkActions(enableBulkAction)
							}
						}
						if (item?.ParameterCode === "SIP_CLIENT") {
							if (item?.ParameterValue === null) {
								setSipClient(item?.DefaultValue);
							} else if (item?.ParameterValue !== null) {
								setSipClient(item?.ParameterValue);
							}
						}
						if (item?.ParameterCode === "BARGE_FROM_USER") {
							let value: boolean = false;
							const uniqueKey = `BARGE_FROM_USER`;
							console.log(`[${uniqueKey}] Checking BARGE_FROM_USER parameter`, item);
							if (item?.ParameterValue === null) {
								value = item?.DefaultValue?.toLowerCase() === "true";
								console.log(`[${uniqueKey}] ParameterValue is null, using DefaultValue:`, item?.DefaultValue, `Evaluated value:`, value);
							} else {
								value = item?.ParameterValue?.toLowerCase() === "true";
								console.log(`[${uniqueKey}] ParameterValue is available:`, item?.ParameterValue, `Evaluated value:`, value);
							}

							if (value) {
								console.log(`[${uniqueKey}] Fetching user barge details:`, value);
								getUserBargeDetails().then((bargeResp: any) => {
									console.log(`[${uniqueKey}] Received barge response:`, bargeResp);
									let sipUrl = bargeResp?.Data?.[0]?.sipLocation;
									console.log(`[${uniqueKey}] Extracted SIP URL:`, sipUrl);
									setSipUrl(sipUrl);
								});
							} else {
								console.log(`[${uniqueKey}] Barge-in is disabled, checking SIP_URL parameter`);
								const sipItem = resp?.Data?.find(
									(i: any) => i?.ParameterCode === "SIP_URL"
								);
								if (sipItem) {
									const resolvedSipUrl = sipItem?.ParameterValue ?? sipItem?.DefaultValue;
									console.log(`[${uniqueKey}] Found SIP_URL parameter:`, sipItem, `Resolved SIP URL:`, resolvedSipUrl);
									setSipUrl(resolvedSipUrl);
								}
							}
						}
					});
				})
				.catch((e) => {
					console.log("error", e);
				});
		} catch (e) {
			console.log("error2 2 2 22", e);
		}
	};

	const continuousBargeEnabled = () => {
		getContinuousBargeStatus().then((resp: any) => {
			if (resp?.isContinueBargeEnabled) {
				setContinuousBarge(resp?.isContinueBargeEnabled);
			}
		})
	};

	const agentClick = async (action: string, agent: any) => {
		try {
			if (action === 'LOGOUT') {
				setOpenLogOffAlert(true);
				setLogOffDetails(agent);
			} else if (action === 'RELEASE') {
				setOpenAlert(true);
				setReleaseDetails(agent);
			} else if (action === 'BARGEIN') {
				setSelectedAgent(agent);
				setOnSelect(true);
				toggleBargeInDrawer();
			} else if (action === "SCREEN_BARGEIN") {
				setScreenBargeinData({ ...agent, onlyBargeinMode });
			} else if (action === "LOG_CONFIG") {
				setLogConfigDetails(agent);
				setOpenLogConfigAlert(true);
			}
		} catch (error) {
			console.error("Failed to fetch agent list", error);
		}
	};

	const agentDetails = async (event: any, agent: any) => {
		setSelectedAgent(agent);
		const agentData = await getAgentStateDetail({ agentId: getAgentIncId(agent) });
		setSelectedAgentDetails(agentData.find((eachAgent) => eachAgent));
		setElRefPoint({ top: event.clientY, left: event.clientX });
		setIsPopoverOpen(true);
	};

	const onHamburgerClick = (event: any) => {
		setColumnsElRefPoint({ top: event.clientY, left: event.clientX });
		setIsColumnsPopoverOpen(true);
	};

	const agentEvents = async (event: any, agent: any) => {
		setSelectedAgent(agent);
		let response = await getAgentEvents({ agentId: getAgentIncId(agent) });
		response = response.map((dataItem: any) => ({
			...dataItem,
			StartTime: dataItem.StartTime ? `${dataItem.StartTime.toString().split(' ')[0]}T${dataItem.StartTime.toString().split(' ')[1]}` : '',
			EndTime: dataItem.EndTime ? `${dataItem.EndTime.split(' ')[0]}T${dataItem.EndTime.toString().split(' ')[1]}` : ''
		}));
		setSelectedAgentEventDetails(response);
		setElRefPoint({ top: event.clientY, left: event.clientX });
		setIsEventsPopoverOpen(true);
	};

	const toggleBargeInDrawer = () => {
		setIsBargeInOpen(!isBargeInOpen);
	};

	const toggleBargeInDrawerSip = (value: any) => {
		setIsBargeInOpen(!isBargeInOpen);
		setBargeinCallType('');
		setOnSelect(false)
	};

	const handleFilterDelete = (id: Number) => {
		const newFilter = agentListFilter.filter((item: any) => item.id !== id);
		setAgentListFilter(newFilter);
		props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
	};

	const clearFilter = () => {
		setAgentListFilter([]);
		setAdditionalFilters({ state: [], mode: [] });
		props?.handleFilterChange?.([], filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify({ state: [], mode: [] }), '', '', false, { data: selectedColumns });
	};

	const handleFilterExistingData = (filteredData: any) => {
		setAgentListFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection, additionalFilters }: any) => {
		console.log("responseLength", responseLength)
		console.log("selectedFilters", selectedFilters)
		setAgentListFilter(selectedFilters);
		setFilterType(newFilterType);
		setFilterSection(newfilterSection);
		setAdditionalFilters(additionalFilters);
		props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
		toggleDrawer(false);
	};

	const handleDragStart = (event: React.DragEvent<HTMLDivElement>, item: any) => {
		event.dataTransfer?.setData('agentData', JSON.stringify(item));
	};

	const handleOnDrop = (event: React.DragEvent<HTMLDivElement>) => {
		const agentData: any = JSON.parse(event.dataTransfer?.getData('agentData') || '{}');

		if (!groupingColumns.find((col: any) => col.id === agentData.id)) {
			let grpCol = [...groupingColumns, agentData];
			setGroupingColumns(grpCol);
			saveDataToDashboard('groupingColumns', grpCol);
		}
		return;
	};

	const toggleThresholdDrawer = (isOpen: boolean, data: any = null, showSkillList: any = false) => {
		setIsThresholdDrawerOpen(isOpen);
		if (data) {
			const savedThresholdList = structuredClone(data);
			setSavedThresholdList((prev: any) => ({
				showSkillList: showSkillList,
				thresholdList: savedThresholdList
			}));
			if (props?.handleThresholdChange) {
				props.handleThresholdChange?.(savedThresholdList, showSkillList, props?.widgetId);
			}
			setThresholdItems(data);
		}
	};


	React.useEffect(() => {
		const filterIds = (agentListFilter.length && !(responseLength === agentListFilter.length)) ? agentListFilter.map((item: any) => item.id).join(',') : '0';
		console.log("filterIds", filterIds, responseLength, agentListFilter.length, (agentListFilter.length || !(responseLength === agentListFilter.length)))
		getTableData(filterIds);
		intervalRef.current = setInterval(() => getTableData(filterIds), WIDGET_REFRESH_INTERVAL.AGENT_LIST);
		return () => {
			clearInterval(intervalRef.current);
		};
	}, [agentListFilter, thresholdItems, additionalFilters]);

	const filterItems = agentListFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	// const autoLogoffFunction = (data: any) => {
	// 	// Define the mapping of agent states and their corresponding time limits
	// 	const agentState: any = {
	// 	  READY_TIME_LIMIT: "READY",
	// 	  AUX_TIME_LIMIT: "AUX",
	// 	  ACW_TIME_LIMIT: "ACW",
	// 	  PAUSE_TIME_LIMIT: "PAUSED",
	// 	};

	// 	// Extract the setting names from the agentState object
	// 	const agentSettings = Object.keys(agentState);

	// 	// Iterate through each row of data
	// 	data?.forEach((row: any) => {
	// 	  // Iterate through each settingName (assuming it's defined somewhere)
	// 	  settings?.forEach((settingName: any) => {
	// 		if (agentSettings.includes(settingName?.ParameterCode)) {
	// 		  const rowSince = parseInt(row?.Since);
	// 		  const settingParameterValue = parseInt(settingName?.ParameterValue ==null ? settingName?.DefaultValue : settingName?.ParameterValue);
	// 		//   console.log("settingName->",settingName,"---->",settingParameterValue);
	// 		  if (settingParameterValue > 0) {
	// 			// Check if the rowSince time is greater than the settingParameterValue
	// 			// and if the AgentState matches the expected state from agentState
	// 			if (
	// 			  rowSince > settingParameterValue &&
	// 			  row.AgentState === agentState[settingName?.ParameterCode]
	// 			) {
	// 			  handleLogOff(row); // Call the handleLogOff function
	// 			}
	// 		  }
	// 		}
	// 	  });
	// 	});
	//   };


	// React.useEffect(()=>{
	// 	getSettings();
	// },[])

	// const  autoLogoffFunction=(data:any)=> {
	// 	const agentState:any = {"READY_TIME_LIMIT": 'READY',"AUX_TIME_LIMIT": 'AUX',"ACW_TIME_LIMIT": 'ACW',"PAUSE_TIME_LIMIT": 'PAUSED'};
	// 	const agentSettings=Object.keys(agentState)
	// 	data?.forEach((row:any)=>{
	// 		settings?.forEach((settingName:any)=>{
	// 			if(agentSettings.includes(settingName?.ParameterCode))
	// 			{
	// 				const rowSince=parseInt(row?.Since);
	// 				const settingParameterValue=parseInt(settingName?.ParameterValue);
	// 				if(rowSince > settingParameterValue && row.AgentState===agentState[settingName?.ParameterCode])
	// 				{
	// 					 handleLogOff(row);
	// 				}
	// 			}
	// 			else
	// 			{
	// 				return 
	// 			}
	// 	})
	// 	})
	// }

	// React.useEffect(()=>{
	// 	getSettings();
	// 	},[])





	const handleClose = () => {
		setOpenAlert(false);
	};
	const handleLogOffClose = () => {
		setOpenLogOffAlert(false);
	};

	const handleCloseLogConfigDialog = () => {
		setOpenLogConfigAlert(false);
	};

	function getHoldStatus(holdDuration: number) {
		if (holdDuration && typeof holdDuration === 'number' && holdDuration > 0) {
			return 'Hold'
		} else {
			return 'Non-Hold'
		}
	}

	function getRowData(row: any) {
		row = row?.map((item: any) => {
			let rowObj = {
				...item,
				SkillsFormatted: item?.AgentSkills ? item?.AgentSkills : item?.AgentSkills,
				GroupsFormatted: item?.AgentGroups ? item?.AgentGroups : item?.AgentGroups,
				Since: secondsToTime(item?.Since),
				HoldDuration: secondsToTime(item?.HoldDuration),
				HoldStatus: getHoldStatus(item?.HoldDuration || 0)
			};
			return rowObj;
		});
		return row;
	}

	const handleLogConfigSubmit = async (agentDetails: any, formValues: any) => {
		try {
			const time = formValues?.logDuration || null;
			let response = await widgetService({
				method: 'POST',
				withUserId: true,
				responseType: 'string',
				bodyParams: {
					action: "adminToAgentReq",
					apiId: 53,
					agentId: agentDetails?.AgentId,
					agentUniqueId: getAgentIncId(agentDetails),
					time: time
				},
			});
			const result = await response.text();
			if (result === "success") {
				showSuccessNotification(`Successfully sent ${time ? 'start' : 'stop'} action to ${agentDetails?.AgentName || 'Agent'}`)
			}
		} catch (e) {
			console.error(e);
		} finally {
			handleCloseLogConfigDialog();
		}
	}

	const handleLogOff = async (row: any) => {
		console.log("row here", row);
		await logoutAgent({ agentUniqueID: getAgentIncId(row), agentId: row.AgentId });
		setOpenLogOffAlert(false);
	};
	const handleRelease = async () => {
		await releaseAgent({ agentUniqueID: getAgentIncId(releaseDetails), agentId: releaseDetails.AgentId });
		setOpenAlert(false);
	};

	React.useEffect(() => {
		let groupedData = {};
		if (groupingColumns.length > 0) {
			for (const data of filteredRowData) {
				groupingColumns
					.reduce((groupAcc: any, column: any, groupIdx: number) => {
						const key = data[column.id] || '';
						groupAcc[key] = groupAcc[key] || (groupIdx === groupingColumns.length - 1 ? [] : {});
						return groupAcc[key];
					}, groupedData)
					.push(data);
			}
		}
		setGroupedData(groupedData);
	}, [groupingColumns, filteredRowData]);


	let finalTableData: any = []
	const getAgentListTableData = () => {
		if (groupingColumns.length) {
			finalTableData = []
			// Sort the grouped data by group names when sorting by grouped columns
			const sortedGroupedData = sortGroupedData(groupedData, groupingColumns);
			getFinalRows(sortedGroupedData, 0);
			return finalTableData;
		} else {
			return sortData(filteredRowData);
		}
	}

	const getFinalRows: any = (data: any, index: number) => {
		if (!Array.isArray(data)) {
			return Object.entries(data).map(([groupName, groupRowData]) => {
				const extraCell: any = {}
				for (let i = 0; i < index; i++) {

					extraCell['extraCell' + i] = ""

				}
				let groupRowDataLength = Array.isArray(groupRowData) ? groupRowData?.length : getLengthOfProps(groupRowData);
				extraCell['index'] = index
				extraCell['groupName'] = groupName;
				extraCell['groupRowDataCount'] = groupRowDataLength;
				finalTableData.push(extraCell);
				getFinalRows(groupRowData, index + 1)
			})

		} else {
			finalTableData = getSortedGroupData(data, finalTableData);
		}
	}

	function AgentListHeaderContent() {
		return (
			<TableRow>
				{groupingColumns.map((groupName: any, idx: number) => {
					return <StyledTableCell key={groupName + idx} align="left"></StyledTableCell>;
				})}
				{bulkActions ? <StyledTableCell key={'bulk-select-header'} align="center" style={{ minWidth: 30, width: 30 }} padding="checkbox">
					<CustomizedCheckbox
						color="primary"
						indeterminate={bulkSelectedAgents.length > 0 && bulkSelectedAgents.length < filteredRowData.length}
						checked={filteredRowData.length > 0 && bulkSelectedAgents.length === filteredRowData.length}
						onChange={handleSelectAllClick}
						inputProps={{
							'aria-label': 'select all agents',
						}}
					/>
				</StyledTableCell> : null}
				{selectedColumns.map((column: any, idx: number) => {
					if (column.id === 'adminAction') {
						return (
							<StyledTableCell key={column.id + idx} align="center" style={{ minWidth: column.minWidth, opacity: isBulkSelectionActive ? 0.4 : 1 }}>
								{column.label}
								<span className="icon-row">
									<span className="icon-col">Release</span>
									<span className="icon-col">Logout</span>
									<span className="icon-col">Bargein</span>
									{enableLogDuration && <span className="icon-col" style={{ minWidth: '100px' }}>Log Configuration</span>}
									{checkRoles("ROLE_SCREEN_RECORDING") && <span className="icon-col icon-full-width">Screen Bargein</span>}
								</span>
							</StyledTableCell>
						);
					} else if (column.draggable) {
						return (
							<StyledTableCell
								key={column.id + idx}
								className="draggable-table-cell"
								align={'left'}
								draggable={true}
								sx={{
									whiteSpace: 'nowrap',
									cursor: 'pointer'
								}}
								onClick={() => handleSort(column.id)}
								onDragStart={(event) =>
									handleDragStart(event, {
										label: column.label,
										id: getColumnId(column)
									})
								}
							>
								<Typography display={'flex'} alignItems={'center'} fontSize={'12px'}>
									<span style={{ padding: '0 0.2rem', paddingTop: 4 }}>
										<DragIcon />
									</span>
									{column.label}
									{getSortIcon(column.id)}
								</Typography>
							</StyledTableCell>
						);
					} else if (column.id === 'hamburger') {
						return (
							<StyledTableCell
								key={column.id + idx}
								style={{
									minWidth: column.minWidth,
									textAlign: 'center'
								}}
							>
								<IconButton onClick={onHamburgerClick}>
									<img src={`${process.env.PUBLIC_URL}/icons/table-hamburger-icon.svg`} width="20" alt="Hamburger" style={{ marginTop: '5px' }}></img>
								</IconButton>
							</StyledTableCell>
						);
					} else {
						return (
							<StyledTableCell
								key={column.id + idx}
								align={column.align}
								style={{ minWidth: column.minWidth, cursor: 'pointer' }}
								onClick={() => handleSort(column.id)}
							>
								{column.label}
								{getSortIcon(column.id)}
							</StyledTableCell>
						);
					}
				})}
			</TableRow >
		)
	}

	const getAgentState = (row: any, value: any) => {
		const holdDuration = row?.HoldDuration
		const extraMark = (((typeof holdDuration === 'object' ? holdDuration?.value : holdDuration) > 0) && value === 'BUSY') ? <PauseCircleIcon sx={{ color: 'red', position: 'absolute', top: -4, right: -9, fontSize: '14px' }} /> : ""
		return row?.PauseReason ?
			<span
				title={value}
				style={{
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					display: 'inline-block',
					maxWidth: ' 100px',
				}} className={STATUS_CLASS_MAP['PAUSED']}>{value}</span>
			:
			<span className={STATUS_CLASS_MAP[value]} style={{ position: 'relative' }}>{value}{extraMark}</span>
	}

	function rowContent(_index: number, row: any) {
		let rowIdx = _index
		if (row.hasOwnProperty('groupName')) {
		}
		const keys = Object.keys(row);
		const indexxx = keys.indexOf('groupName');
		let colorr = getLevelColor(indexxx);
		return (
			(row.hasOwnProperty('groupName')) ?
				<React.Fragment>
					{keys.map((key, i) => {
						if (key === 'groupName') {
							return <StyledTableCell key={key} colSpan={selectedColumns.length + groupingColumns.length} sx={{ padding: '5px 16px', background: colorr }}>
								{row.groupName} {`${row.groupRowDataCount > 0 ? `(${row.groupRowDataCount})` : ''}`}
							</StyledTableCell>
						} if (key.includes('extraCell')) {
							return <StyledTableCell key={key} sx={{ background: colorr }}>
								{''}
							</StyledTableCell>
						}
					})}
				</React.Fragment >
				:

				<React.Fragment>

					{groupingColumns.map((groupName: any, idx: number) => {
						return <StyledTableCell key={groupName + idx} align="left"></StyledTableCell>;
					})}
					{bulkActions ? getBulkSelectionCell(row, `${rowIdx}-bulk-virtual`) : null}
					{selectedColumns.map((column: any) => {
						const value = row[column.id];
						if (column.id === 'agentAction') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={column.align} className="">
									<span className="icon-row">
										<span className="icon-col-sm">
											<IconButton disableRipple onClick={(event) => agentDetails(event, row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-info-icon.svg`} width="20" alt="Info"></img>
											</IconButton>
										</span>
										<span className="icon-col-sm">
											<IconButton disableRipple onClick={(event) => agentEvents(event, row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-graph-icon.svg`} width="20" alt="Graph"></img>
											</IconButton>
										</span>
									</span>
								</StyledTableCell>
							);
						} else if (column.id === 'adminAction') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={'center'} >
									<span className="icon-row" style={{ opacity: isBulkSelectionActive ? 0.4 : 1, pointerEvents: isBulkSelectionActive ? 'none' : 'auto' }}>
										<span className="icon-col" style={{ cursor: row.AgentState === 'BUSY' && isAdminActionSettingEnabled ? 'not-allowed' : 'pointer' }}>
											<IconButton disabled={isBulkSelectionActive || (row.AgentState === 'BUSY' && isAdminActionSettingEnabled)} disableRipple onClick={() => agentClick('RELEASE', row)} aria-label="delete">
												<img src={`${process.env.PUBLIC_URL}/icons/table-release-icon.svg`} width="16" alt="Release"></img>
											</IconButton>
										</span>
										<span className="icon-col" style={{ cursor: row.AgentState === 'BUSY' && isAdminActionSettingEnabled ? 'not-allowed' : 'pointer' }}>
											<IconButton disabled={isBulkSelectionActive || (row.AgentState === 'BUSY' && isAdminActionSettingEnabled)} disableRipple onClick={() => agentClick('LOGOUT', row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-logout-icon.svg`} width="16" alt="Logout"></img>
											</IconButton>
										</span>
										<span className="icon-col">
											<IconButton disableRipple disabled={isBulkSelectionActive || row.AgentState !== 'BUSY' || (row.AgentMode === 'DIGITAL' && row.AgentState === 'BUSY')} onClick={() => agentClick('BARGEIN', row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/table-bargein-icon.svg`} width="16" alt="Bargein"></img>
											</IconButton>
										</span>
										{enableLogDuration && <span className="icon-col" style={{ minWidth: '100px' }}>
											<IconButton disableRipple onClick={() => agentClick('LOG_CONFIG', row)}>
												<img src={`${process.env.PUBLIC_URL}/icons/settings-icon.svg`} width="16" alt="Log Configuration"></img>
											</IconButton>
										</span>}
										{checkRoles("ROLE_SCREEN_RECORDING") && <span className="icon-col cursor-pointer" onClick={() => agentClick("SCREEN_BARGEIN", row)}>
											<ScreenBargeinIcon />
										</span>}
									</span>
								</StyledTableCell>
							);
						} else if (column.id === 'hamburger') {
							return (
								<StyledTableCell key={column.id + rowIdx} align={'center'}>
									{value === 'expand' && (
										<span className="icon-row">
											<span className="icon-col">
												<img src={`${process.env.PUBLIC_URL}/icons/table-expand-icon.svg`} width="10" alt="Expand"></img>
											</span>
										</span>
									)}
								</StyledTableCell>
							);
						} else if (column.id === 'AgentState') {
							return (
								<StyledTableCell key={column.id} align={column.align}>
									{getAgentState(row, value)}
								</StyledTableCell>
							);
						}
						else {
							return (
								<StyledTableCell
									key={column.id + rowIdx}
									align={column.align}
									title={typeof value === 'object' ? '' : value}
									sx={{
										whiteSpace: 'nowrap',
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										maxWidth: '190px',
									}}
									className={`${row[column.id]?.warning || ''}`}
								>
									{(column.type === 'MIN_SEC' && secondsToMinSec(row[column.id]?.value || row[column.id])) ||
										(column.type === 'TIME' && secondsToTime(row[column.id]?.value || row[column.id])) ||
										value}
								</StyledTableCell>
							);
						}
					})}
				</React.Fragment>
		);
	}

	const getTableStyle = () => {
		let height = 54;
		if (agentListFilter.length > 0 || additionalFiltersLength > 0) {
			height += 14;
		}
		return `calc(100% - ${height}px)`;
	}

	const handleSelectSearchField = (type: any = null) => {
		if (type) {
			setSearchSelect(type);
			if (searchKeyRef) {
				searchKeyRef.current = type?.key || '';
			}
		}
		setSearchFieldMenuAnchorEl(null);
	};

	const handleSearchFieldMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		if (event.currentTarget) setSearchFieldMenuAnchorEl(event.currentTarget);
	};

	const searchFields: any = [
		{ name: 'Agent Id', key: 'AgentId' },
		{ name: 'Agent Name', key: 'AgentName' },
		{ name: 'Campaign', key: 'CampaignNameOfLastCall' },
		// { name: 'Skills', key: 'SkillsFormatted' },
		{ name: 'Skills', key: 'AgentSkills' },
	];

	const additionalFiltersList = () => {
		try {
			return Object.keys(additionalFilters).map((key: any) => {
				if (additionalFilters[key]?.length === 0) return null;
				return additionalFilters[key].map((item: any, index: number) => (
					<Chip
						key={index}
						label={`${key.toUpperCase()} - ${item}`}
						color="primary"
						variant="outlined"
						onDelete={() => {
							setAdditionalFilters((prev: any) => {
								let newFilters = { ...prev };
								newFilters[key] = newFilters[key]?.filter((_: any) => _ !== item);
								props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(newFilters), '', '', false, { data: selectedColumns });
								return newFilters;
							});
						}}
						deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
				))
			})
		} catch (e) {
			console.log("error", e)
		}
	}

	function saveDataToDashboard(key: string, data: any) {
		if (props && props?.handleSaveDataToFilter) {
			props?.handleSaveDataToFilter({
				widgetId: props?.widgetId,
				value: {
					[key]: data
				}
			})
		}
	}

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = filteredRowData.map((n: any) => {
				const agentIncId = getAgentIncId(n);
				return agentIncId ? String(agentIncId) : null;
			}).filter((id: any) => id !== null) as string[];
			setBulkSelectedAgents(newSelecteds);
			return;
		}
		setBulkSelectedAgents([]);
	};

	return (
		<Card className={!moreData ? "changedCustomCard" : resized ? "changedCustomCard" : "customCard"} ref={tableContainerRef}>
			<div className="card-header">
				<div className="card-title">
					Agent List <div className="card-title-badge">Live</div>
					{loadingRef.current && <CircularProgress size={16} sx={{ ml: 1 }} />}
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<Grid container style={{ border: '1px solid #D6D6D7', borderRadius: '8px 0px 0px 8px', backgroundColor: '#F2F2F2', width: '125px', marginRight: '18rem' }}>
						<Grid item sx={{ display: 'flex' }}>
							<div style={{ flexGrow: 1, minWidth: '100px' }} onClick={handleSearchFieldMenuOpen}>
								<Typography
									variant="caption"
									sx={{
										fontWeight: 400,
										fontSize: '12px',
										textAlign: 'right',
										color: '#212121',
										cursor: 'pointer',
										paddingLeft: '15px',
									}}
								>
									{searchSelect.name}
								</Typography>
							</div>
							<Menu
								sx={{ width: '50px' }}
								anchorEl={searchFieldMenuAnchorEl}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								open={labelOpen}
								onClose={() => handleSelectSearchField()}
								PaperProps={{ className: classes.dropdownMenu }}
								container={fullscreenContainer}
							>
								{searchFields?.map((eachField: any, idx: any) => {
									return (
										<MenuItem key={idx} className={classes.dropdownLabelMenuItem} onClick={() => handleSelectSearchField(eachField)}>
											{eachField.name}
										</MenuItem>
									);
								})}
							</Menu>
							<KeyboardArrowDownOutlinedIcon style={{ color: '#536580', fontSize: '10px', marginRight: '13px', marginTop: 10 }} />
							<WidgetSearch widget onTextChange={handleOnSearch}></WidgetSearch>
						</Grid>
					</Grid>
					{/* <WidgetSearch onTextChange={handleOnSearch}></WidgetSearch> */}
					<WidgetDownload fullscreenContainer={fullscreenContainer} element={tableDataRef} name={'Agent List'} xlsx rowData={getRowData(rowData)} columns={selectedDownloadData}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={agentListFilter.length + additionalFiltersLength} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
					<div onClick={() => toggleThresholdDrawer(true)}>
						<WidgetGraph></WidgetGraph>
					</div>
				</div>
			</div>
			<FilterDrawer
				isOpen={isDrawerOpen}
				toggleDrawer={toggleDrawer}
				applyFilters={handleApplyFilters}
				existingSelectedFilters={agentListFilter}
				setResponseLength={setresponseLength}
				allowedFilters={allowedFilters}
				existingFilterCategory={filterType}
				applyFilterOnExistingData={handleFilterExistingData}
				showAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? ['state', 'mode'] : []}
				initialAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? additionalFilters : { state: [], mode: [] }}
				disableCampaignGroupSelection={true}
				fullscreenContainer={fullscreenContainer}
			/>
			{/* <FilterDrawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} existingSelectedFilters={agentListFilter} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData}/> */}
			<Box sx={{ pt: 2, pl: 2 }}>
				{(agentListFilter.length > 0 || additionalFiltersLength > 0) && (
					<div className="filter-outer">
						<div className="filter-container">
							<Stack direction="row" spacing={1}>
								{agentListFilter.length > 0 && filterItems}
								{additionalFiltersLength > 0 && additionalFiltersList()}
							</Stack>
						</div>
						<div className="filter-remove" onClick={clearFilter}>
							Remove
						</div>
					</div>
				)}

			</Box>
			{isBulkSelectionActive && (
				<Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1, flexWrap: 'wrap', gap: 1 }}>
					<Typography variant="body2">
						{`${bulkSelectedAgents.length} agent${bulkSelectedAgents.length > 1 ? 's' : ''} selected`}
					</Typography>
					<Stack direction="row" spacing={2} alignItems="center" ml={2}>
						<Button sx={{ borderRadius: '8px' }} size="small" variant="contained" onClick={handleBulkRelease} disabled={bulkActionLoading !== null}>
							{bulkActionLoading === 'release' ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : 'Release'}
						</Button>
						<Button sx={{ borderRadius: '8px' }} size="small" variant="outlined" onClick={handleBulkLogout} disabled={bulkActionLoading !== null}>
							{bulkActionLoading === 'logout' ? <CircularProgress size={16} /> : 'Log out'}
						</Button>
						<Button sx={{ borderRadius: '8px' }} size="small" variant="text" onClick={clearBulkSelection}>
							Clear
						</Button>
					</Stack>
				</Box>
			)}
			<div className="search-drag-drop" onDrop={handleOnDrop} onDragOver={(e) => e.preventDefault()}>
				{groupingColumns.length > 0 && (
					<Box className={classes.dragdropItemsWrapper}>
						<div className="filter-outer">
							<div className="filter-container">
								<Stack direction="row" spacing={1}>
									{groupingColumns.map((item: any, index: number) => (
										<Chip
											key={index}
											label={item.label}
											color="primary"
											variant="outlined"
											onDelete={() => {
												setGroupingColumns((prev: any) => {
													let grpCol = prev.filter((_: any) => _.id !== item.id);
													saveDataToDashboard('groupingColumns', grpCol);
													return grpCol;
												})
											}}
											deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />}
										/>
									))}
								</Stack>
							</div>
							<div className="filter-remove" onClick={() => {
								setGroupingColumns([]);
								saveDataToDashboard('groupingColumns', []);
							}}>
								Remove
							</div>
						</div>
					</Box>
				)}
				<Typography
					component={'span'}
					color="#99A0A8"
					position="absolute"
					// top={'50'}
					// left={'50'}
					fontSize={'12px'}
				>
					{groupingColumns.length < 3 && 'Drag and drop the metrics for grouping '}
					{/* <span>
					(Currently you don’t have any metrics which can be grouped)
				</span> */}
				</Typography>
			</div>
			<Paper sx={{
				width: '100%', overflow: 'hidden',
				height: getTableStyle(),
			}}>
				{/* For auto height adjust uncomment below line
					<TableContainer className="custom-table-scroll" sx={{ maxHeight: '500vw' }}> */}
				<VirtualTable
					tableDataRef={tableDataRef}
					data={getAgentListTableData()}
					HeaderContent={AgentListHeaderContent}
					rowContent={rowContent}
				/>
			</Paper>
			<Popover
				open={isPopoverOpen}
				onClose={handleOnPopoverClose}
				anchorReference="anchorPosition"
				anchorPosition={eleRefPoint}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				container={fullscreenContainer}
			>
				{getPopoverContent()}
			</Popover>
			<Popover
				open={isEventsPopoverOpen}
				onClose={handleOnEventsPopoverClose}
				anchorReference="anchorPosition"
				anchorPosition={eleRefPoint}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				container={fullscreenContainer}
			>
				{getEventsPopoverContent()}
			</Popover>
			{/* {bargeinCallType === "Normal" &&
				<BargeInDrawer isOpen={isBargeInOpen} toggleDrawer={toggleBargeInDrawer} agentDetails={selectedAgent} />
			}
			{bargeinCallType === 'SIP' && onselect &&
				<BargeInDrawerSip isOpen={isBargeInOpen} toggleDrawer={toggleBargeInDrawerSip} agentDetails={selectedAgent} callType={bargeinCallType} url={sipUrl} SipClient={sipClient} />
			} */}
			{/* modified to use single component for both normal and sip */}
			{onselect &&
				<BargeInDrawerSip container={fullscreenContainer} isOpen={isBargeInOpen} toggleDrawer={toggleBargeInDrawerSip} agentDetails={selectedAgent} callType={bargeinCallType} url={sipUrl} SipClient={bargeinCallType === 'SIP' ? sipClient : undefined} />
			}
			{screenBargeinData && <VideoPlayerIcon
				row={{ liveRecordingData: screenBargeinData }}
				isLive={true}
				hideIcon={true}
				defaultOpen={true}
				onClose={() => { setScreenBargeinData(null) }}
				fullscreenContainer={fullscreenContainer}
			/>}

			<ThresholdDrawer
				container={fullscreenContainer}
				isOpen={isThresholdDrawerOpen}
				title={'Set'}
				toggleDrawer={toggleThresholdDrawer}
				thresholdItems={thresholdItems}
				savedThresholdList={savedThresholdList?.thresholdList || []}
				showSkillListByDefault={savedThresholdList.showSkillList}
			/>
			<SelectPopover
				isOpen={isColumnsPopoverOpen}
				elementsArray={columns}
				anchorRef={columnsEleRefPoint}
				handlePopoverClose={handleOnColumnsPopoverClose}
				selectedElements={selectedColumns}
				handleOnSelectionChange={handleOnSelectColumnChange}
			/>
			<Dialog container={fullscreenContainer} open={openAlert} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{'Release'}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{`Are you sure you want to release agent ${releaseDetails?.AgentName}`}?</DialogContentText>
				</DialogContent>
				<DialogActions>
					<div className="buttons-container">
						<Button variant="outlined" onClick={() => handleClose()}>
							Cancel
						</Button>
						<Button variant="contained" onClick={handleRelease} sx={{ ml: 2 }}>
							Release
						</Button>
					</div>
				</DialogActions>
			</Dialog>
			<Dialog container={fullscreenContainer} open={openLogOffAlert} onClose={handleLogOffClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{'Logout'}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{`Are you sure you want to Logout agent ${logOffDetails?.AgentName}`}?</DialogContentText>
				</DialogContent>
				<DialogActions>
					<div className="buttons-container">
						<Button variant="outlined" onClick={() => handleLogOffClose()}>
							Cancel
						</Button>
						<Button variant="contained" onClick={() => { handleLogOff(logOffDetails) }} sx={{ ml: 2 }}>
							Logout
						</Button>
					</div>
				</DialogActions>
			</Dialog>
			<Formik
				initialValues={{ logDuration: 5 }}
				validationSchema={logConfigFormValidationSchema}
				onSubmit={(formValues) => {
					handleLogConfigSubmit(logConfigDetails, formValues)
				}}>
				{(formik) => (
					<div>
						<form
							onSubmit={formik.handleSubmit}
							id="logDurationForm"
						>
							<Dialog container={fullscreenContainer} open={openLogConfigAlert} onClose={handleCloseLogConfigDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" PaperProps={{ sx: { minWidth: "500px" } }}>
								<DialogTitle id="alert-dialog-title">{'Log Duration Configuration'}</DialogTitle>
								<DialogContent>
									<OZInput
										name="logDuration"
										label="Duration"
										placeholder="Enter Log Duration"
										type="number"
									/>

								</DialogContent>
								<DialogActions>
									<Button variant="outlined" color='error' onClick={() => handleCloseLogConfigDialog()} sx={{ borderRadius: '6px' }}>
										Cancel
									</Button>
									<Button variant="contained" color='error' onClick={() => handleLogConfigSubmit(logConfigDetails, { logDuration: null })} sx={{ borderRadius: '6px', ml: 2 }}>
										Stop
									</Button>
									<Button variant="contained" sx={{ ml: 2, borderRadius: '6px' }} type='submit' form="logDurationForm" >
										Start
									</Button>
								</DialogActions>
							</Dialog>

						</form>
					</div>
				)}
			</Formik>
		</Card>
	);
}
